<template>
    <div class="card-wrap" @click="handleMore(list.detailUrl)">
        <img :src="list.appLogoFullUrl" />
        <div class="title text-overflow-ellipsis" :title="list.appTitle">{{ list.appTitle }}</div>
        <div class="desc text-overflow-ellipsis-2">{{ list.appProfile }}</div>
        <div class="tag-wrap" v-show="list.appTags">
            <template v-for="item in list.appTags.split(' ')">
                <div class="tag" :key="item" v-if="item">
                    {{ item }}
                </div>
            </template>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        list: {
            default: () => {
                return {};
            },
        },
    },
    methods: {
        handleMore(detailUrl) {
            window.open(detailUrl);
        },
    },
}
</script>
<style lang="less" scoped>
.card-wrap {
    width: 319px;
    height: 210px;
    background: #FFFFFF;
    box-shadow: 1px 1px 0px 0px rgba(243, 245, 248, 1);
    margin-right: 1px;
    margin-bottom: 1px;
    padding: 20px 30px;
    cursor: pointer;

    &:hover {
        position: relative;
        box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.1);
    }

    img {
        width: 44px;
        height: 44px;
        object-fit: contain;
    }

    .title {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #354052;
        letter-spacing: 0;
        font-weight: 600;
        margin-top: 13px;
    }

    .desc {
        height: 50px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #354052;
        letter-spacing: 0;
        line-height: 25px;
        font-weight: 400;
    }

    .tag-wrap {
        height: 21px;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        overflow: hidden;
        margin-top: 6px;

        .tag {
            background: #F2F6FA;
            border: 1px solid rgba(231, 235, 239, 1);
            border-radius: 2px;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #354052;
            letter-spacing: 0;
            line-height: 19px;
            font-weight: 400;
            padding: 0 9px;
            margin-right: 9px;
        }
    }
}
</style>